import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import Button from '../button/button';
import Icon from '../icon/icon';
import Menu from '../menu/menu';
import { DesktopContainer, NavebarButtonsStyles } from './navBar.styles';
import { useAuthContext } from './../../../context/AuthContext';

export default function DesktopNav({
  pages,
  hoveredButton,
  handleButtonEnter,
  handleButtonLeave,
  getButtonMenuItems,
  getMenuColumns,
  menuAnchorEl,
  handleMenuClose,
  handleMenuLeaveMenu,
  handleMenuEnter,
}) {
  const { isAuthorized } = useAuthContext();

  // Create desktop menu item components based on ACF custom metadata
  const createDesktopNavComponent = {
    button: (props, customStyle = {}) => <Button
      color={props.background_color === "text" ? "#000000" : props?.background_color}
      size={props.size}
      sx={{
        ...customStyle
      }}
      href={props?.url || '/'}
      variant={props?.button_variant}
    >
      {props.title}
    </Button>,
    typography: (props) => (
      <Typography fontFamily={props?.fontfamily} fontStyle={props?.fontstyle} fontWeight={props?.fontweight}>
        {props.add_html_content ?
          <div dangerouslySetInnerHTML={{ __html: props.html_content }} /> :
          props?.text_content}
      </Typography>
    ),
    icon: (props) => <Icon type={props?.custom_icon} fontSize="medium" color="#11728D" />,
    iconButton: (props) =>
      props?.custom_icon && (
        <Button
          color={
            props.background_color === "text" ? "#000000" : props?.background_color
          }
          fontFamily="body.fontFamily.secondary"
          fontWeight="400"
          variant={props?.button_variant}
          href={props?.url}
          sx={{
            fontSize: { xs: "13px", lm: "16px" },
            my: 2,
            display: "flex",
            ...NavebarButtonsStyles,
          }}
        >
          <Box sx={{ px: "10px" }}>
            <Icon
              color={
                props.background_color === "text" ? "#000000" : props?.background_color
              }
              sx={{
                fontSize: { xs: "13px", lm: "16px" },
              }}
              type={props?.custom_icon}
            />
          </Box>
          {props?.title}
        </Button>
      ),

  };

  return (
    <Box sx={DesktopContainer}>

      {pages.map((page, index) => {
        const buttonType = page?.title || page;
        const pagesLength = pages.length - 1;
        if (pagesLength != index) {
          return page?.menuItems && page?.menuItems.length > 0 ? (<Button
            variant="text"
            color="#000000"
            fontFamily="body.fontFamily.secondary"
            fontWeight="700"
            key={index}
            hoverBottomBorderSize="5px"
            onMouseOver={event => handleButtonEnter(event, buttonType)}
            // onMouseOut={handleButtonLeave}
            sx={{
              my: 2,
              display: 'flex',
              zIndex: 2000,
              minHeight: '60px',
              ...NavebarButtonsStyles,
              // Apply transparent background on hover
              '&:hover': {
                backgroundColor: 'transparent',
              }
            }}
          >
            {buttonType}
            <Box
              sx={{
                px: '10px',
                transform: hoveredButton === buttonType ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease-in-out',
              }}
            >
              <Icon color="#000000" fontSize="6.32px" type="expandarrow" />
            </Box>
          </Button>) : (
            <React.Fragment key={index}>
              {(page?.acf.isbutton && page?.acf.custom_icon === 'Select Icon') ? createDesktopNavComponent.button(page?.acf, {
                py: 2,
                my: 2,
                display: "block",
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }) : ((page?.acf.isbutton && page?.acf.custom_icon !== 'Select Icon') ? createDesktopNavComponent.iconButton(page?.acf) : createDesktopNavComponent.typography(page?.acf))}
            </React.Fragment>
          )
        }

      }
      )}
      {getButtonMenuItems(hoveredButton).length > 0 && (
        <Menu
          columns={getMenuColumns(hoveredButton)}
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
          menuItems={getButtonMenuItems(hoveredButton)}
          onMouseOut={handleMenuLeaveMenu}
          onMouseOver={handleMenuEnter}
          sx={{ mt: 3 }}
          key={hoveredButton}
          className={hoveredButton}
        />
      )}
    </Box>
  );
}

DesktopNav.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.string),
  hoveredButton: PropTypes.string,
  handleButtonEnter: PropTypes.func,
  handleButtonLeave: PropTypes.func,
  getButtonMenuItems: PropTypes.func,
  getMenuColumns: PropTypes.func,
  menuAnchorEl: PropTypes.object,
  handleMenuClose: PropTypes.func,
  handleMenuLeaveMenu: PropTypes.func,
  handleMenuEnter: PropTypes.func,
};
